module.exports = __webpack_public_path__ + "static/img/amd4.4c581a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd4.png
// module id = IgdD
// module chunks = 1